import { useEffect, useState } from "react";
import Api, { BaseUrl } from "../../../api/Api";
import LoadingStuck from "../../reuse/LoadingStuck";
import { Accordion, Button, Card, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import Select from "react-select";
import { AuditorsTestShortNames, AuditorsTestStructure, AuditorsTestStructureAll } from "./AuditorsTestStructure";


const createAudit = async(data) => {
        try {
            const response = await Api({
                method:"post",
                url:`/audits/add`,
                headers:{},
                data:data
            })
            alert("Аудит создан");
            window.location.href="/main_page"
        } catch (error) {
            // alert("Ошибка при создании аудита;")
            alert(`Ошибка при создании аудита \n ${error}`)
        }
    }

const setAuditorsTestStructure = (auditorsAllData, auditorsCurrentData) => {
    const result={};
    Object.keys(auditorsCurrentData).forEach((partName)=>{
        const resultAllCategoires={}
        if(auditorsAllData[partName].length!==0){
            Object.keys(auditorsCurrentData[partName]).forEach((categoryName)=>{
                resultAllCategoires[categoryName]=auditorsAllData[partName];
            })
            result[partName]=resultAllCategoires;
        }else{
            Object.keys(auditorsCurrentData[partName]).forEach((categoryName)=>{
                if(auditorsCurrentData[partName][categoryName].length!==0){
                    resultAllCategoires[categoryName]=auditorsCurrentData[partName][categoryName];
                }
            })
            result[partName]=resultAllCategoires;
        } 
    })

    const send_result = {};
    Object.keys(result).forEach((partName)=>{
        if (Object.keys(result[partName]).length!==0){
            send_result[partName]=result[partName];
        }
    })
    return send_result
}

const AuditFormInterface = ({testId, usersOptions, 
    facilityOptions, selfEsteemOption, 
    auditorsTestStructure, AuditorsTestBlockAll, shortNames}) => {

    const [leaderValue,setLeaderValue]=useState("");
    const [facilityValue,setFacilityValue]=useState("");
    const [esteemAuditValue,setEsteemAuditValue]=useState("");

    const [auditorsCurrentData,setAuditorsCurrentData]=useState(auditorsTestStructure);
    const [auditorsAllData,setAuditorsAllData]=useState(AuditorsTestBlockAll);

    const handleSave = async(e) => {
        e.preventDefault();
        const name_values=[
            new Date(document.getElementById("start_datetime").value).toISOString().split("T")[0] || "",
            facilityOptions.find((elem) =>elem.value === facilityValue )?.label || "",
            document.getElementById("name").value || ""]
        const data = {
        name:name_values.join("-"),
        description:document.getElementById("description").value,
        test_id:testId,
        results_access:document.getElementById("results_access").checked,
        notify_auditors:document.getElementById("notify_auditors").checked,
        audit_type:document.getElementById("audit_type").value,
        start_datetime:document.getElementById("start_datetime").value,
        end_datetime:document.getElementById("end_datetime").value,
        activation:document.getElementById("activation").value,

        "esteem_audit":esteemAuditValue?.value || null,
        "facility_id":facilityValue?.value || null,
        "audit_leader":leaderValue?.value || null,
        }

        data["auditors"]=setAuditorsTestStructure(auditorsAllData, auditorsCurrentData);
        // console.log(data["auditors"]);
        if (Object.keys(data["auditors"]).length==0){
            alert("Выберите хотя бы одного аудитора на один раздел.");
        }else{
            await createAudit(data);
            // console.log(data)
        }
    }

    const handleAuditorAllChange = (partName,selected) => {
        auditorsAllData[partName]=selected.map((option)=>option.value);
    }
    const handleAuditorCurrentChange = (partName, category, selected) =>{
        auditorsCurrentData[partName][category]=selected.map((option)=>option.value);
    }

    return(<>
    <Form 
    onSubmit={handleSave}
    >
        <Card className="mb-2 mt-2">
            <Card.Header><div className="text_font">Информация об аудите</div></Card.Header>
            <Card.Body>
                <div>
                    <div>
                        <Form.Control 
                        id="name"
                        className="mb-1"
                        type="text"
                        placeholder="Название аудита..."
                        />

                         <Form.Control 
                        id="description"
                        className="mb-1"
                        as="textarea" 
                        placeholder="Описание аудита"/>
                    </div>
                    <div>
                        <Row className="mb-1">
                            <Col md={4}>
                                <Form.Text>Рассылка по email</Form.Text>
                                <Form.Check 
                                type="switch"
                                id="notify_auditors"
                                label="Не рассылать/Рассылать"
                                /> 
                            </Col>
                            <Col md={4}>
                                <Form.Text>Тип аудита</Form.Text>
                                <Form.Select
                                id="audit_type">
                                    <option value="common">Обычный</option>
                                    <option value="self-esteem">Самоаудит</option>
                                </Form.Select>
                            </Col>
                            <Col md={4}>
                                <Form.Text>Активация</Form.Text>
                                <Form.Select id="activation">
                                    <option value="on_demand">По требованию</option>
                                    <option value="by_datetime">По расписанию</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col md={4}>
                                <Form.Text>Доступ к результатам</Form.Text>
                                <Form.Check 
                                id="results_access"
                                type="switch" 
                                label="Не давать/Дать"/>
                            </Col>
                            <Col md={4}>
                                <Form.Text>Дата начала</Form.Text>
                                <Form.Control 
                                required
                                id="start_datetime"
                                type="datetime-local" 
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Text>Дата окончания</Form.Text>
                                <Form.Control 
                                required
                                id="end_datetime"
                                type="datetime-local" 
                                />
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <Col md={4}>
                            <Form.Text>Самоаудит</Form.Text>
                             <Select 
                                id="esteem_audit"
                                placeholder="Самоаудит..."
                                onChange={(e)=>setEsteemAuditValue(e)}
                                options={selfEsteemOption} 
                                className="mb-2"
                                isClearable/>
                            </Col>
                            <Col md={4}>
                                <Form.Text>Завод</Form.Text>
                                <Select 
                                id="facility_id"
                                placeholder="Завод..." 
                                onChange={(e)=>setFacilityValue(e)}
                                options={facilityOptions} 
                                isClearable 
                                className="mb-2"
                                required/>
                            </Col>
                            <Col md={4}>
                                <Form.Text>Лидер аудита</Form.Text>
                                <Select 
                                id="audit_leader"
                                placeholder="Лидер..." 
                                onChange={(e)=>setLeaderValue(e)}
                                options={usersOptions} 
                                isClearable 
                                className="mb-2"
                                required/>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Card.Body>
        </Card>
        <Accordion className="mt-1" defaultActiveKey={"auditBlock"} alwaysOpen flush>
            <Accordion.Item className="mb-1 border" eventKey="auditBlock">
                <Accordion.Header><div className="text_font">Аудиторы</div></Accordion.Header>
                <Accordion.Body>
                    <Accordion defaultActiveKey="end_false_key">
                        {Object.keys(auditorsTestStructure).map((partName, index)=>(
                            <Accordion.Item key={index} eventKey={index}>
                                <Accordion.Header>
                                    <div className="text_font">{partName}</div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    {/* {JSON.stringify(Object.keys(AuditorsTestBlock[partName]))} */}
                                    <Tabs
                                    defaultActiveKey="all"
                                    variant="pills"
                                    id="uncontrolled-tab-example"
                                    className="mb-3"
                                    >
                                    <Tab eventKey="all" title="Все">
                                        <Form.Text className="text_font">Все</Form.Text>
                                        <Select 
                                        // id={`${index}-${partName}-all`}
                                        isMulti 
                                        placeholder="Аудитор..."
                                        onChange={(selected)=>{handleAuditorAllChange(partName,selected)}}
                                        options={usersOptions} 
                                        isClearable/>
                                    </Tab>
                                    <Tab eventKey="category" title="По подразделам">
                                        {Object.keys(auditorsTestStructure[partName]).map((category, index)=>(
                                            <div className="mb-2">
                                            <Form.Text className="text_font">{shortNames[partName][category]} {category}</Form.Text>
                                            <Select 
                                            isMulti 
                                            placeholder="Аудитор..."
                                            onChange={(selected)=>{handleAuditorCurrentChange(partName,category,selected)}}
                                            options={usersOptions} 
                                            isClearable/>
                                            </div>
                                        ))
                                        }
                                    </Tab>
                                    </Tabs>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Accordion.Body>   
            </Accordion.Item>
        </Accordion>
        <div className="m-1">
            <Button type="submit" size="lg">Создать аудит</Button>
        </div>
    </Form>
    </>)
}

const AuditFormController = ({testId, usersOptions, 
    facilityOptions, selfEsteemOption, 
    auditorsTestStructure, AuditorsTestBlockAll,shortNames}) => {
        
        return(
            <AuditFormInterface 
            testId={testId}
            usersOptions={usersOptions}
            facilityOptions={facilityOptions}
            selfEsteemOption={selfEsteemOption}
            auditorsTestStructure={auditorsTestStructure}
            AuditorsTestBlockAll={AuditorsTestBlockAll}
            shortNames={shortNames}
            />
        )

} 

const AuditElements = ({testId, dataUsers, dataFacility, dataSelfEsteem, dataTest}) => {
    if (dataUsers.length===0){
        return(<p>В системе нет пользователей! Создайте хотя бы одного пользователя.</p>)
    }
    if (dataFacility.length===0){
        return(<p>В системе нет предприятий! Создайте хотя бы одно предприятие.</p>)
    }

    const usersOptions=dataUsers.map((item, index)=>{return {
        label:`${index+1})${item.surname||""} ${item.name||""} ${item.patronymic || ""}(${item.username})`,
        value:item.username
    }})
    const facilityOptions=dataFacility.map((item,index)=>{
        return{ label:item.short_name, value:item.id}
    })
    const selfEsteemOption=dataSelfEsteem.map((item,index)=>{
        return{label:item.name, value:item.id}
    })
    
    const auditorsTestStructure=AuditorsTestStructure(dataTest.data);
    const AuditorsTestBlockAll=AuditorsTestStructureAll(dataTest.data);
    const shortNames=AuditorsTestShortNames(dataTest.data);
    
    return(<>
    <AuditFormController
    testId={testId}
    usersOptions={usersOptions}
    facilityOptions={facilityOptions}
    selfEsteemOption={selfEsteemOption}
    auditorsTestStructure={auditorsTestStructure}
    AuditorsTestBlockAll={AuditorsTestBlockAll}
    shortNames={shortNames}
    /></>)
    
} 


const AuditInfoFetch = ({testId}) => {
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(false);

    const [errorInfo,setErrorInfo]=useState(null);

    const [dataUsers,setDataUsers]=useState(null);
    const [dataTest,setDataTest]=useState(null);
    const [dataFacility,setDataFacility]=useState(null);
    const[dataSelfEsteem, setDataSelfEsteem]=useState(null);

    const getUsers = async() => {
        try {
            const response = await Api({
                 method:"get",
                url:`/users/`,
                headers:{}
            });
            return(response);
        } catch (error) {
            throw `Ошибка при получении данных о пользователях \n ${error}`
        }
    }

    const getFacility = async()=>{
        try {
            const response = await Api({
                 method:"get",
                url:`/facilities/`,
                headers:{}
            });
            return(response);
        } catch (error) {
            throw `Ошибка при получении данных о предприятиях \n ${error}`
        }
    }

    const getTestData = async(test_id)=>{
        try {
            const response = await Api({
                method:"get",
                url:`/tests/@${test_id}`,
                headers:{}
            });
            return(response);
        } catch (error) {
            throw `Ошибка при получении данных о тесте ${test_id} \n ${error}`
        }
    }

    const getSelfEsteem = async(test_id)=>{
        try {
            const response = await Api({
                method:"get",
                url:`/audits/my_audits/self-esteem?test_id=${test_id}`,
                headers:{}
            });
            return(response);
        } catch (error) {
            throw `Ошибка при получении данных о самоаудитах теста ${test_id} \n ${error}`
        }
    }

    const getAllData = async() => {
        try {
            const userData=await getUsers();
            setDataUsers(userData.data);

            const facilitiesData=await getFacility();
            setDataFacility(facilitiesData.data);

            const testData=await getTestData(testId);
            setDataTest(testData.data);

            const selfEsteemData=await getSelfEsteem(testId);
            setDataSelfEsteem(selfEsteemData.data);

            setBlock(true);
        } catch (error) {
            setErrorInfo(error);
            setError(true);
        }
    }

    useEffect(()=>{
        const setUp = async() => {
            setLoading(true);
            await getAllData();
            setLoading(false);
        };
        setUp();
    },[])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<p className="warning_text">{errorInfo}</p>)}
    if(block){return(<AuditElements 
        testId={testId}
        dataUsers={dataUsers}
        dataFacility={dataFacility}
        dataTest={dataTest}
        dataSelfEsteem={dataSelfEsteem} />)}
}

const TestBlock = ({data}) => {
    const [testId, setTestId]=useState(null);
    if(data.length===0){
        return(<p className="warning_text">Перед организации аудита создайте хотя бы один тест.</p>)
    }

    const test_options=data.map((item)=>({label:item.name, value:item.id}))||[]

    const renderRestForm = () => {
        if(testId==null){return(<></>)}
        return(<AuditInfoFetch testId={testId}/>)
    }
    
    return(<>
        <Card>
            <Card.Header className="text_font">Тест Аудита</Card.Header>
            <Card.Body>
                <Select 
                placeholder="Выберите тест" 
                options={test_options} 
                isClearable
                onChange={(option) => setTestId(option?.value || null)}/>
            </Card.Body>
        </Card>
        <div>
            {renderRestForm()}
        </div>
    </>)
}

const FetchTests = () => {
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(false);

    const [errorInfo,setErrorInfo]=useState(null);
    const [data,setData]=useState(null);

    const getData = async() => {
        try {
            const response = await Api({
                method:"get",
                url:`/tests/`,
                headers:{} 
            })
            setBlock(true);
            setData(response.data)            
        } catch (error) {
            // setErrorInfo("Ошибка при получении данных о тестах");
            setErrorInfo(`Ошибка при получении данных о тестах \n ${error}`);
            setError(true);
        }
    }
    
    useEffect(()=>{
        const setUp = async() => {
            setLoading(true)
            await getData();
            setLoading(false)
        };
        setUp();
    },[])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<p className="warning_text">{errorInfo}</p>)}
    if(block){return(<><TestBlock data={data}/></>)}
}

const PlaningAuditBlock = () => {
    return(<FetchTests/>)
}

export default PlaningAuditBlock;